import type { U3141ChildLotChain } from '../U3141Service';

function u3141PositionKey(pos: { x: number; y: number } | null | undefined): string | null {
  if (pos == null || typeof pos.x !== 'number' || typeof pos.y !== 'number') {
    return null;
  }
  return `${pos.x},${pos.y}`;
}

/**
 * BL-0707 — Détecte un snapshot graphe dont les positions sauvegardées ne permettent pas une lecture (empilement).
 * Vrai si : aucune position ; ou toutes les positions présentes sont identiques ; ou ≥ 2 nœuds et au plus une coordonnée distincte.
 */
export function u3141GraphNodePositionsAreDegenerate(rows: U3141ChildLotChain[]): boolean {
  if (!Array.isArray(rows) || rows.length === 0) {
    return false;
  }
  if (rows.length === 1) {
    return false;
  }

  const distinctKeys = new Set<string>();
  let withPosition = 0;

  for (const row of rows) {
    const key = u3141PositionKey(row.nodePosition);
    if (key == null) {
      continue;
    }
    withPosition += 1;
    distinctKeys.add(key);
  }

  if (withPosition === 0) {
    return true;
  }

  if (withPosition === rows.length && distinctKeys.size === 1) {
    return true;
  }

  if (rows.length >= 2 && distinctKeys.size <= 1) {
    return true;
  }

  return false;
}
